// src/components/management/Users.jsx
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import "../../styles/components/management/Users.css";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function Users() {
  //const [email, setEmail] = useState("");
  //const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    surname: "",
    email: "",
    password: "",
    role_id: "",
    company_id: "",
  });
  const [filters, setFilters] = useState({ role: "", company: "" });
  const [selected, setSelected] = useState([]);
  const { user } = useAuth();

  const fetchAll = async () => {
    const res = await fetch(
      `${API_BASE}/app/API/rbmgt/add_user.php`
    );
    const data = await res.json();

    if (data.success) {
      setUsers(data.users);
      setRoles(data.roles);
      setCompanies(data.companies);
    }
  };

  useEffect(() => {
    fetchAll();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const logAudit = async (action, details) => {
    await fetch(`${API_BASE}/app/API/rbmgt/AuditLogs.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: user?.id || 0,
        user_name: `${user?.name || "System"} ${user?.surname || ""}`.trim(),
        action,
        details,
      }),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const method = formData.id ? "PUT" : "POST";
    const res = await fetch(
      `${API_BASE}/app/API/rbmgt/add_user.php`,
      {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );
    const data = await res.json();
    if (data.success) {
      await logAudit(
        formData.id ? "Edit User" : "Add User",
        `${formData.name} ${formData.surname} (${formData.email})`
      );
      setFormData({
        id: null,
        name: "",
        surname: "",
        email: "",
        password: "",
        role_id: "",
        company_id: "",
      });
      fetchAll();
    } else {
      setError(data.message);
    }
    setLoading(false);
  };

  const handleEdit = (user) => {
    setFormData({
      id: user.USER_ID,
      name: user.USER_NAME,
      surname: user.USER_SURNAME,
      email: user.USER_EMAIL,
      password: "",
      role_id: user.USER_ROLE_ID,
      company_id: user.USER_COMPANY_ID,
    });
  };

  const handleDelete = async (id) => {
    const userToDelete = users.find((u) => u.USER_ID === id);
    if (!userToDelete) {
      alert("User not found.");
      return;
    }

    if (
      !window.confirm(
        `Delete ${userToDelete.USER_NAME} ${userToDelete.USER_SURNAME}?`
      )
    )
      return;

    await fetch(
      `${API_BASE}/app/API/rbmgt/add_user.php?id=${id}`,
      {
        method: "DELETE",
      }
    );

    await logAudit(
      "Delete User",
      `Deleted user ${userToDelete.USER_NAME} ${userToDelete.USER_SURNAME} (ID: ${id})`
    );

    fetchAll();
  };

  const handleBulkDelete = async () => {
    if (!window.confirm("Delete selected users?")) return;

    const usersToDelete = users.filter((u) => selected.includes(u.USER_ID));

    await Promise.all(
      usersToDelete.map((user) =>
        fetch(
          `${API_BASE}/app/API/rbmgt/add_user.php?id=${user.USER_ID}`,
          { method: "DELETE" }
        )
      )
    );

    const details = usersToDelete
      .map(
        (user) => `${user.USER_NAME} ${user.USER_SURNAME} (ID: ${user.USER_ID})`
      )
      .join("; ");

    await logAudit("Bulk Delete Users", `Deleted users: ${details}`);

    setSelected([]);
    fetchAll();
  };

  const filteredUsers = users.filter((u) => {
    const matchesRole =
      !filters.role || String(u.USER_ROLE_ID) === String(filters.role);
    const matchesCompany =
      !filters.company || String(u.USER_COMPANY_ID) === String(filters.company);
    return matchesRole && matchesCompany;
  });

  return (
    <div className="users-section">
      <form onSubmit={handleSubmit} className="user-form">
        <input
          name="name"
          placeholder="First Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          name="surname"
          placeholder="Surname"
          value={formData.surname}
          onChange={handleChange}
          required
        />
        <input
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          name="password"
          type="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required={!formData.id}
        />
        <select
          name="role_id"
          value={formData.role_id}
          onChange={handleChange}
          required
        >
          <option value="">Select Role</option>
          {roles.map((role) => (
            <option key={role.ROLE_ID} value={role.ROLE_ID}>
              {role.ROLE_NAME}
            </option>
          ))}
        </select>
        <select
          name="company_id"
          value={formData.company_id}
          onChange={handleChange}
          required
        >
          <option value="">Select Company</option>
          {companies.map((comp) => (
            <option key={comp.COMPANY_ID} value={comp.COMPANY_ID}>
              {comp.COMPANY_NAME}
            </option>
          ))}
        </select>
        <button type="submit" disabled={loading}>
          {formData.id ? "Update" : "Add"} User
        </button>
        {error && <p style={{ color: "red" }}>{error}</p>}
      </form>

      <div className="filters">
        <select
          value={filters.role}
          onChange={(e) => setFilters({ ...filters, role: e.target.value })}
        >
          <option value="">All Roles</option>
          {roles.map((r) => (
            <option key={r.ROLE_ID} value={r.ROLE_ID}>
              {r.ROLE_NAME}
            </option>
          ))}
        </select>
        <select
          value={filters.company}
          onChange={(e) => setFilters({ ...filters, company: e.target.value })}
        >
          <option value="">All Companies</option>
          {companies.map((c) => (
            <option key={c.COMPANY_ID} value={c.COMPANY_ID}>
              {c.COMPANY_NAME}
            </option>
          ))}
        </select>
        {selected.length > 0 && (
          <button onClick={handleBulkDelete}>Delete Selected</button>
        )}
      </div>
      <div className="user-table-container">
        <table className="user-table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setSelected(
                      e.target.checked ? users.map((u) => u.USER_ID) : []
                    )
                  }
                />
              </th>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Company</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <tr key={user.USER_ID}>
                <td>
                  <input
                    type="checkbox"
                    checked={selected.includes(user.USER_ID)}
                    onChange={(e) => {
                      setSelected(
                        e.target.checked
                          ? [...selected, user.USER_ID]
                          : selected.filter((id) => id !== user.USER_ID)
                      );
                    }}
                  />
                </td>
                <td>
                  {user.USER_NAME} {user.USER_SURNAME}
                </td>
                <td>{user.USER_EMAIL}</td>
                <td>{user.ROLE_NAME}</td>
                <td>{user.COMPANY_NAME}</td>
                <td>
                  <button onClick={() => handleEdit(user)}>Edit</button>
                  <button onClick={() => handleDelete(user.USER_ID)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
